module.exports = __webpack_public_path__ + "img/icone-local-roxo.875b62ed.svg";